class FooterLegacy {
  constructor(event, data) {
    this.event = event;
    this.data = data;
  }

  googleFormat() {
    const googleFormattedData = {};
    switch (this.event) {
      case 'footerCountryChanged': {
        googleFormattedData.event = this.data.eventInfo.eventName;
        googleFormattedData.country = this.data.attributes.country;

        break;
      }

      default:
        throw Error(`Event ${this.event} is not registered`);
    }
    return googleFormattedData;
  }
}

export default FooterLegacy;
